module.exports = __webpack_public_path__ + "static/media/livingroom.ec0c827e.png";